import classNames from "classnames";
import { Entry } from "contentful";

import Editorials from "~/types/editorials";
import { assertEditorialType, isActiveEntry } from "~/utils/editorial-utils";

import styles from "./breakpoint-aware-asset.module.scss";
import OptimizedMediaAsset from "./optimized-media-asset";

type Props = {
  entry: Entry<unknown>;
  className?: string;
  videoConfig?: {
    muted?: boolean;
    loop?: boolean;
    autoPlay?: boolean;
    controls?: boolean;
    playsInline?: boolean;
  };
  noLazy?: boolean;
};

export default function OptimizedBreakpointAwareAsset({ entry, className, ...rest }: Props) {
  assertEditorialType<Editorials.ContentAwareAsset>(entry, "breakpointAwareAsset");
  if (!entry || !entry.fields || !isActiveEntry(entry)) return null;

  return (
    <>
      <OptimizedMediaAsset entry={entry} className={classNames(styles.mobileAsset, className)} {...rest} />
      <OptimizedMediaAsset entry={entry} isWideSize className={classNames(styles.desktopAsset, className)} {...rest} />
    </>
  );
}
